import { useEffect, useMemo, useState } from "react";

export default function LiveClock({ timeZone = "Europe/Athens" }) {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const id = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(id);
    }, []);

    const formatted = useMemo(() => {
        return new Intl.DateTimeFormat("el-GR", {
            timeZone,
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        }).format(now);
    }, [now, timeZone]);

    return <span>{formatted}</span>;
}
